export const name = '@lifi/widget'
export const version = '4.6.0'
